// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Account_disclaimer__139iM","container":"Account_container__15C_7","content":"Account_content__3t19i","table":"Account_table__12yJG"};